import { http } from '@/libs/util'
import util from '@/libs/util'
export const { 
    dimission_wage_list,
    dimission_wage_save,
    dimission_wage_delete,
    director_informal_wage_topic_batch_add_customer,
    director_informal_wage_topic_export_template,
    import_informal_wage_records
 } = util.api || {}

 export function getDimissionWageListApi(params) {
    return http.get(dimission_wage_list, params)
}

export function getSaveDimissionWageApi(params) {
    return http.post(dimission_wage_save, params)
}

export function deleteSaveDimissionWageApi(params) {
    return http.post(dimission_wage_delete, params)
}

export function setBatchAddCustomerApi(params) {
    return http.post(director_informal_wage_topic_batch_add_customer, params)
}

export function importBatchApi(formData) {
    return http.post_upload(import_informal_wage_records, { formData })
}